<style>
.eso-breadcrumb span , .eso-breadcrumb .breadcrumb{
  float: left;
}
.eso-breadcrumb .breadcrumb{
  margin: 0 0;
}
.eso-breadcrumb span {
  color:#777;
}
.eso-breadcrumb .el-breadcrumb{
  float: left;
  margin-left: 10px;
  margin-top: 1px;
}
</style>

<template>
  <div class="eso-breadcrumb clearfix">
    <span>所处位置 : </span>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <template v-for="breadcrumb in breadcrumbs">
        <el-breadcrumb-item :to="breadcrumb">{{breadcrumb.text}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: ['breadcrumbs']
}
</script>



// WEBPACK FOOTER //
// breadcrumb.vue?005f6bc0